<!-- 抽奖活动配置 -->
<template>
  <div class='content'>
    <el-form ref="form" label-width="auto" align="left" :inline="true">
      <el-form-item label="活动名称：">
        <el-input placeholder="输入商品名称" @change="getTableList()" v-model="params.activityName"></el-input>
      </el-form-item>
      <el-form-item label="状态：">
        <el-select v-model="params.status">
          <el-option value="0" label="全部"></el-option>
          <el-option value="1" label="进行中"></el-option>
          <el-option value="2" label="已结束"></el-option>
          <el-option value="3" label="未开始"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="getTableList()">搜索</el-button>
        <el-button size="small" @click="resetParams();getTableList();">重置</el-button>
        <el-button size="small" type="primary" @click="title='新增活动';resetForm();dialogVisible=true">新增</el-button>
      </el-form-item>
    </el-form>

    <el-table 
      :data="tableData"
      class="mt-20"
      :header-cell-style="{'text-align':'center'}"
      :cell-style="{'text-align':'center'}">
      <!-- show-overflow-tooltip -->
      <el-table-column label="活动编号" prop="activityId"></el-table-column>
      <el-table-column label="活动名称" prop="activityName"></el-table-column>
      <el-table-column label="活动类型" prop="activityType">
        <template slot-scope="scope">{{ scope.row.activityType|activityTypeFilters }}</template>
      </el-table-column>
      <el-table-column label="背景图" prop="activityIcon">
        <template slot-scope="scope">
          <el-image 
            style="width: 50px; height: 50px"
            :src="scope.row.activityIcon|getImgUrl" 
            :preview-src-list="[cache.fetchOssPath() || 'https://img.91cdkey.com/'+scope.row.activityIcon]">
          </el-image>
        </template>
      </el-table-column>
      <el-table-column label="开始时间" prop="startTime"></el-table-column>
      <el-table-column label="结束时间" prop="endTime"></el-table-column>
      <el-table-column label="状态" prop="status">
        <template slot-scope="scope">{{ scope.row.status|statusFilters }}</template>
      </el-table-column>
      <el-table-column label="抽一次积分" prop="onePrice"></el-table-column>
      <el-table-column label="抽十次积分" prop="tenPrice"></el-table-column>
      <el-table-column label="已抽取数" prop="usedStock"></el-table-column>
      <el-table-column label="奖池剩余数" prop="totalStock">
        <template slot-scope="scope">{{ scope.row.totalStock - scope.row.usedStock }}</template>
      </el-table-column>
      <el-table-column fixed="right" label="操作">
        <template slot-scope="scope">
          <el-button 
            type="text" 
            size="small" 
            @click="editGame(scope.row.activityId)">编辑</el-button>
          <el-button 
            type="text" 
            size="small" 
            @click="go(scope.row.activityId,scope.row.activityName)">奖品配置</el-button>
          <el-button 
            type="text" 
            size="small" 
            @click="activityTitle(scope.row.activityId)">文案配置</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-row class="mt-15 mr-20 text-right" v-if="total > 0">
      <el-pagination 
        small layout="total,prev,pager, next,sizes,jumper" 
        :page-size="params.pageSize"
        :total="total" 
        :current-page.sync="params.pageNum" 
        :page-sizes="[10 ,20 , 30, 40, 50]"
        @size-change="handleSizeChange" 
        @current-change="handleCurrentChange">
      </el-pagination>
    </el-row>

    <!-- 新增/编辑 -->
    <el-dialog :title="title" top="20px" :visible.sync="dialogVisible"> 
      <el-form :model="form" ref="form" :rules="rules" label-width="auto">
        <el-form-item label="活动标题：" prop="activityName">
          <el-input type="text" v-model="form.activityName" placeholder="请输入活动标题"></el-input>
        </el-form-item>
        <el-form-item label="图片：" prop="activityIcon">
          <ImageUpload :url="form.activityIcon" @image-uploaded="form.activityIcon = $event" />
        </el-form-item>
        <el-form-item label="抽一次积分：" prop="onePrice">
          <el-input type="text" v-model="form.onePrice" placeholder="请输入抽一次积分"></el-input>
        </el-form-item>
        <el-form-item label="抽十次积分：" prop="tenPrice">
          <el-input type="text" v-model="form.tenPrice" placeholder="请输入抽十次积分"></el-input>
        </el-form-item>
        <el-form-item label="活动类型：" prop="activityType">
          <el-select v-model="form.activityType" placeholder="请选择活动类型">
            <el-option label="游利社" value="0"></el-option>
            <el-option label="livelink" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间段：" required>
          <el-date-picker
            v-model="time"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            @change="dateChange">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <el-row class="text-right mt-20">
        <el-button @click="resetForm();title='';dialogVisible=false">取消</el-button>
        <el-button type="primary" :loading="buttonLoading" @click="confirm()">确定</el-button>
      </el-row>
    </el-dialog>

    <!-- 文案 -->
    <el-dialog title="修改文案" top="20px" width="50%" :visible.sync="activityTitleDialogVisible"> 
      <el-form :model="activityTitleForm" ref="activityTitleForm" :rules="activityTitleRules" label-width="auto">
        <el-form-item label="奖品说明：" prop="prizeDesc">
          <vue-ueditor-wrap v-model="activityTitleForm.prizeDesc" :config="myConfig"></vue-ueditor-wrap>
        </el-form-item>
        <el-form-item label="规则说明：" prop="ruleDesc">
          <vue-ueditor-wrap v-model="activityTitleForm.ruleDesc" :config="myConfig"></vue-ueditor-wrap>
        </el-form-item>
      </el-form>
      <el-row class="text-right mt-20">
        <el-button @click="resetActivityTitleForm();activityTitleDialogVisible=false">取消</el-button>
        <el-button type="primary" :loading="buttonLoading" @click="confirmActivityTitle()">确定</el-button>
      </el-row>
    </el-dialog>
  </div>
</template>
 
<script>
  import VueUeditorWrap from 'vue-ueditor-wrap';
  export default {
    components:{VueUeditorWrap},
    data() {
      //这里存放数据
      return {
        params:{
          activityName:'',
          status: '0',
          pageNum: 1,
          pageSize: 10
        },
        total: 0,
        time:'',
        tableData:[],
        title: '新增游戏',
        dialogVisible: false,
        activityTitleDialogVisible: false,
        form:{ 
          activityId: null,
          activityName: '',
          activityIcon: '',
          onePrice: '',
          tenPrice: '',
          activityType: '',
          startTime: '',
          endTime: ''
        },
        activityTitleForm: {
          activityId: null,
          prizeDesc: '',
          ruleDesc: ''
        },
        rules:{
          activityName: [{ required: true, message: "请输入活动标题", trigger: "blur" }],
          activityIcon: [{ required: true, message: "请上传背景图", trigger: "blur" }],
          onePrice: [{ required: true, message: "请输入抽一次积分", trigger: "blur" }],
          tenPrice: [{ required: true, message: "请输入抽十次积分", trigger: "blur" }],
          activityType: [{ required: true, message: "请选择活动类型", trigger: "change" }],
        },
        activityTitleRules:{
          prizeDesc: [{ required: true, message: "请输入奖品说明", trigger: "blur" }],
          ruleDesc: [{ required: true, message: "请输入规则说明", trigger: "blur" }],
        },
        buttonLoading: false,
        myConfig: {
          // 编辑器不自动被内容撑高
          autoHeightEnabled: false,
          // 初始容器高度
          initialFrameHeight: 240,
          // 初始容器宽度
          initialFrameWidth: '100%',
          // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
          //serverUrl: 'http://35.201.165.105:8000/controller.php',
          serverUrl: this.ajax.baseUrl + 'oss/editorResources',
          // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
          UEDITOR_HOME_URL: '/static/UEditor/'
        },
      };
    },
    filters:{
      statusFilters(status){
        switch (status) {
          case 0:
            return '全部';
          case 1:
            return '进行中';
          case 2:
            return '已结束';
          case 3:
            return '未开始';
          default:
            break;
        }
      },
      activityTypeFilters(type){
        switch (type) {
          case 0:
          case '0':
            return '游利社';
          case 1:
          case '1':
            return 'livelink';
          default:
            return '--';
        }
      }
    },
    //方法集合
    methods: {
      /**获取列表数据 */
      getTableList(){
        this.ajax.fetch({
          url: this.apis.lotteryActivity.get,
          disableLoading: true,
          method: 'post',
          param: this.params,
          successFunc: res=>{
            this.total = res.total;
            this.tableData = res.result;
          },
          errorFunc: err=>{
            this.$message.error(err.info);
          }
        });
      },
      go(activityId,activityName){
        this.$router.push({path: '/lotteryActivityTaskPrizes', query: {activityId,activityName}});
      },
      activityTitle(activityId){
        let data = this.tableData.filter(i => i.activityId == activityId)[0];
        this.activityTitleForm.activityId = data.activityId;
        this.activityTitleForm.prizeDesc = data.prizeDesc;
        this.activityTitleForm.ruleDesc = data.ruleDesc;
        this.activityTitleDialogVisible = true;
      },
      editGame(activityId){
        let data = this.tableData.filter(i => i.activityId == activityId)[0];
        this.form.activityId = data.activityId;
        this.form.activityName = data.activityName;
        this.form.activityIcon = data.activityIcon;
        this.form.onePrice = data.onePrice;
        this.form.tenPrice = data.tenPrice;
        this.form.activityType = data.activityType === null || data.activityType === undefined ? '' : String(data.activityType);
        this.form.startTime = data.startTime;
        this.form.endTime = data.endTime;
        this.time = [data.startTime, data.endTime];
        this.title = '编辑商品';
        this.dialogVisible = true;
      },
      /**确定 */
      confirm(){
        this.$refs["form"].validate((valid) => {
          if (valid) {
            if (!this.form.startTime) return this.$message.error('请选择时间段');
            if (!this.form.endTime) return this.$message.error('请选择时间段');
            if (this.form.activityId == null) {
              this.ajax.fetch({
                url: this.apis.lotteryActivity.add,
                disableLoading: true,
                method: 'post',
                param: this.form,
                successFunc: res=>{
                  this.$message.success('新增成功!');
                  this.dialogVisible = false;
                  this.resetForm();
                  this.getTableList();
                },
                errorFunc: err=>{
                  this.$message.error(err.info);
                }
              });
            }else{
              this.ajax.fetch({
                url: this.apis.lotteryActivity.update,
                disableLoading: true,
                method: 'post',
                param: this.form,
                successFunc: res=>{
                  this.$message.success('编辑成功!');
                  this.dialogVisible = false;
                  this.resetForm();
                  this.getTableList();
                },
                errorFunc: err=>{
                  this.$message.error(err.info);
                }
              });
            }
          }
        });
      },
      confirmActivityTitle(){
        this.$refs["activityTitleForm"].validate((valid) => {
          if (valid) {
            this.ajax.fetch({
              url: this.apis.lotteryActivity.updateActivityRemark,
              disableLoading: true,
              method: 'post',
              param: this.activityTitleForm,
              successFunc: res=>{
                this.$message.success('修改成功!');
                this.activityTitleDialogVisible = false;
                this.resetActivityTitleForm();
                this.getTableList();
              },
              error: err=>{
                this.$message.error(err.info);
              }
            });
          }
        });
      },
      dateChange(value) {
        this.form.startTime = value[0];
        this.form.endTime = value[1];
      },
      resetForm(){
        this.form={ 
          activityId: null,
          activityName: '',
          activityIcon: '',
          onePrice: '',
          tenPrice: '',
          activityType: '',
          startTime: '',
          endTime: ''
        }
      },
      resetActivityTitleForm(){
        this.activityTitleForm = {
          activityId: null,
          prizeDesc: '',
          ruleDesc: ''
        }
      },
      handleSizeChange(page) {
        this.params.pageSize = page;
        this.getTableList();
      },
      handleCurrentChange(val){
        this.params.pageNum = val;
        this.getTableList();
      },
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
      this.getTableList();
    },
  }
</script>

<style lang='scss' scoped>

</style>



// WEBPACK FOOTER //
// src/page/activityManage/lotteryActivity/lotteryActivity.vue